import {z} from 'zod';

/**
 * Schema for PUT /:id request parameters
 */
export const updatePromptParamsRequestSchema = z.object({
  id: z.string().uuid(),
});

/**
 * Schema for PUT /:id request body
 */
export const updatePromptRequestSchema = z.object({
  userPrompt: z.string().min(1),
  systemPrompt: z.string().min(1),
});

export type UpdatePromptRequestSchema = z.infer<typeof updatePromptRequestSchema>;
